import { Text } from '@/components/ui/text';
import { FeedList } from '@/features/activity/components/feed-list';
import { useActivityFeed } from '@/features/activity/hooks/use-activity';
import { useLikeCheckIn } from '@/features/activity/hooks/use-like-check-in';
import { SuggestedFriends } from '@/features/friends/components/suggested-friends';
import { useAppTheme } from '@/providers/theme-provider';
import React, { useMemo } from 'react';
import { ActivityIndicator, View } from 'react-native';

export function FriendsFeedTab() {
  const {
    data,
    isLoading,
    error,
    refetch,
    isRefetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useActivityFeed();
  const { toggleLike } = useLikeCheckIn();
  const theme = useAppTheme();

  const items = useMemo(
    () => data?.pages.flatMap((page) => page.items) ?? [],
    [data],
  );

  if (isLoading) {
    return (
      <View className="flex-1 items-center justify-center">
        <ActivityIndicator size="large" color={theme.colors.primary} />
      </View>
    );
  }

  if (error) {
    return (
      <View className="flex-1 items-center justify-center px-8">
        <Text className="text-sm text-center text-muted-foreground">Something went wrong. Pull down to try again.</Text>
      </View>
    );
  }

  return (
    <FeedList
      items={items}
      hasNextPage={hasNextPage ?? false}
      isFetchingNextPage={isFetchingNextPage}
      isRefetching={isRefetching}
      onLoadMore={() => fetchNextPage()}
      onRefresh={() => refetch()}
      onLike={toggleLike}
      ListEmptyComponent={
        <>
          <View className="flex-1 items-center justify-center px-8 py-16">
            <Text className="text-xl font-semibold text-center mb-2 text-foreground">
              No activity yet
            </Text>
            <Text className="text-sm text-center mb-6 text-muted-foreground">
              Add friends to see what they&apos;re eating!
            </Text>
          </View>
          <SuggestedFriends />
        </>
      }
    />
  );
}
